import { Flex, Typography } from "antd";

const { Text } = Typography;

interface KeyValueRowProps {
	label: string;
	value: React.ReactNode;
	className?: string;
	labelClassName?: string;
	valueClassName?: string;
	bold?: boolean;
}

export const KeyValueRow = ({
	label,
	value,
	className,
	labelClassName,
	valueClassName,
	bold,
}: KeyValueRowProps) => (
	<Flex justify="space-between" align="center" className={className}>
		<Text className={labelClassName}>{label}</Text>
		<Text strong={bold} className={valueClassName}>
			{value}
		</Text>
	</Flex>
);
